export default class {
  constructor() {
    this.header = document.getElementById('header');
    this.toggleMenuBtn = this.header.querySelector('[data-toggle-menu]');
    this.headerOpenedClass = 'header--opened';
    this.menuLinks = this.header.querySelectorAll('.menu__link');
  }

  bindEvents() {
    this.toggleMenu()
    this.onLinksClick()
    this.onLinksHover()
  }

  toggleMenu() {
    this.toggleMenuBtn.addEventListener('click', () => {
      if (!this.header.matches(`.${this.headerOpenedClass}`)) {
        this.openMenu()
      } else {
        this.closeMenu()
      }
    })
  }

  openMenu() {
    this.header.classList.add(this.headerOpenedClass)
  }

  closeMenu() {
    this.header.classList.remove(this.headerOpenedClass)
  }

  onLinksClick() {
    this.menuLinks.forEach((link, i) => {
      link.addEventListener('click', () => {
        this.closeMenu()
      })
    });
  }

  onLinksHover() {
    this.menuLinks.forEach((link, i) => {
      let activeLink;

      link.addEventListener('mouseover', () => {
        let isActiveLink = false;
        this.menuLinks.forEach((linkIn, j) => {
          if (linkIn.matches('.active')) {
            isActiveLink = true;
            activeLink = linkIn;
            linkIn.classList.remove('active')
          }
        });
        if (!isActiveLink) {
          activeLink = null;
        }
      })

      link.addEventListener('mouseout', () => {
        if (activeLink) {
          activeLink.classList.add('active')
        }
      })
    });
  }

}
